// import coordtransform  from "./coordtransform.js";
//克隆对象
export const cloneObj = function(obj) {
  let o;
  if (typeof obj === "object") {
    if (obj === null) {
      o = null;
    } else {
      if (obj instanceof Array) {
        o = [];
        for (let i = 0, len = obj.length; i < len; i++) {
          o.push(cloneObj(obj[i]));
        }
      } else {
        o = {};
        for (let j in obj) {
          o[j] = cloneObj(obj[j]);
        }
      }
    }
  } else {
    o = obj;
  }
  return o;
};
/**
 * 判断是否全部是中文
 */
export const isAllChinese = function(str) {
  let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
  return reg.test(str);
};
// 停止冒泡兼容
export const stopPropagation = function(e) {
  e = window.event || e;
  if (document.all) {
    // 只有ie识别
    e.cancelBubble = true;
  } else {
    e.stopPropagation();
  }
};
// 计算文字像素长度
export const computeTextLength = function(text, _fontSize) {
  if (!text) {
    return 0;
  }
  let fontSize = _fontSize || 14;
  let temp = "";
  let tempLen = 0;
  text = `${text}`;
  for (let i = 0, n = text.length; i < n; i++) {
    temp = text.charCodeAt(i);
    if (temp > 256) {
      tempLen += fontSize;
    } else {
      tempLen += fontSize / 2;
    }
  }
  tempLen += text.split("\n").length - 1;
  return tempLen;
};

export const checkHash = function(self) {
  setTimeout(() => {
    let hash = self.$route.hash;
    if (hash) {
      let dom = document.querySelector(hash);
      if (dom) {
        dom.scrollIntoView(true);
        if (self.$global.doScrollTop) {
          self.$global.doScrollTop(dom.offsetTop);
        }
      }
      location.hash = hash;
    } else {
      if (self.$global.doScrollTop) {
        self.$global.doScrollTop(0);
      }
    }
  }, 0);
};

// export const coordinateTransform = function(from, to, lnglat){
//     if (typeof(lnglat) != 'string') {
//         return null;
//     }
//     var coordinate = null;
//     var coords = lnglat.split(',');
//     if (coords.length < 2) {
//         return null;
//     }
//     if (from === 'baidu' && (to === 'google' || to === 'amap')) {
//         coordinate = coordtransform.bd09togcj02(coords[0], coords[1]);
//         return new L.LatLng(coordinate[1], coordinate[0]);
//     } else if (from === 'baidu' && (to === 'tianditu')) {
//         coordinate = coordtransform.bd09togcj02(coords[0], coords[1]);
//         coordinate = coordtransform.gcj02towgs84(coordinate[0], coordinate[1]);
//         return new L.LatLng(coordinate[1], coordinate[0]);
//     } else if ((from === 'google' || from === 'amap') && to === 'baidu') {
//         coordinate = coordtransform.gcj02tobd09(coords[0], coords[1]);
//         return new L.LatLng(coordinate[1], coordinate[0]);
//     } else if ((from === 'tianditu') && to === 'baidu') {
//         coordinate = coordtransform.wgs84togcj02(coords[0], coords[1]);
//         coordinate = coordtransform.gcj02tobd09(coordinate[0], coordinate[1]);
//         return new L.LatLng(coordinate[1], coordinate[0]);
//     } else if (from === to) {
//         return new L.LatLng(coords[1], coords[0]);
//     } else {
//         return new L.LatLng(coords[1], coords[0]);
//     }
// }



// WEBPACK FOOTER //
// ./src/assets/javascript/utils.js